import React, {FC} from 'react';
import {connect} from 'react-redux';

import {DataEventTrackingProvider} from '../../../../../libs/shared/core/src/services/tracking/dataEventTrackingProvider';
import {ResolveDispatchProps} from '../../../../../libs/shared/core/src/store/helpers/reduxHelpers';
import {LightUserThemeProvider} from '../../../../../libs/shared/ui/src/theme/userThemeProvider';
import {makeMapDispatchToProps} from '../../../../../srcCommon/helpers/reselectHelpers';
import {useOnboardingModalState} from '../../../app/topBar/onboarding/onboardingContext';
import {OnboardingGuidesEnum} from '../../guide/onboardingGuideTypes';
import {QuickInvitePopover} from './quickInvitePopover';

/*
 * Props.
 */

interface QuickInvitePopoverContainerProps {}

type QuickInvitePopoverContainerComponentProps = QuickInvitePopoverContainerProps &
  ResolveDispatchProps<typeof mapDispatchToProps>;

/*
 * Component.
 */

const QuickInvitePopoverContainerComponent: FC<QuickInvitePopoverContainerComponentProps> = () => {
  const {
    renderOnboardingGuideTransition,
    setOnboardingGuide,
    onboardingGuide,
    quickInvitePopoverEmails,
    setQuickInvitePopoverEmails,
    quickInvitePopoverIsGlobalAdmin,
    setQuickInvitePopoverIsGlobalAdmin,
  } = useOnboardingModalState();

  const isQuickInvitePopoverOpen = onboardingGuide === OnboardingGuidesEnum.QUICK_INVITE;

  if (!isQuickInvitePopoverOpen) {
    return null;
  }

  return (
    // TODO: Add dark mode support in slides (waiting on design.)
    <LightUserThemeProvider>
      <DataEventTrackingProvider context={{name: 'getting_started', payload: {}}}>
        <QuickInvitePopover
          onClose={() => setOnboardingGuide(undefined)}
          renderQuickInviteTransition={(render) =>
            renderOnboardingGuideTransition(OnboardingGuidesEnum.QUICK_INVITE, render)
          }
          isQuickInvitePopoverOpen={isQuickInvitePopoverOpen}
          emails={quickInvitePopoverEmails}
          onChangeEmails={setQuickInvitePopoverEmails}
          isGlobalAdmin={quickInvitePopoverIsGlobalAdmin}
          onChangeIsGlobalAdmin={setQuickInvitePopoverIsGlobalAdmin}
        />
      </DataEventTrackingProvider>
    </LightUserThemeProvider>
  );
};

/*
 * Redux.
 */

const mapDispatchToProps = makeMapDispatchToProps()(() => ({}));

export const QuickInvitePopoverContainer = connect(
  null,
  mapDispatchToProps,
)(QuickInvitePopoverContainerComponent);
